import React, { FC } from 'react';
import { CustomButton } from '@mindly/ui-components';
import { IonIcon } from '@ionic/react';
import { checkmarkCircleOutline } from 'ionicons/icons';
import {
  SubscriptionActionModalText,
  SubscriptionActionModalTitle,
} from '../../CancelSubscriptionModal/CancelSubscriptionModal.style';
import { FormattedMessage } from 'react-intl';

type FinishStepProps = {
  handleClose: () => void;
};

const FinishStep: FC<FinishStepProps> = ({ handleClose }) => {
  return (
    <div className={'finish-step-wrapper'}>
      <IonIcon icon={checkmarkCircleOutline} />
      <SubscriptionActionModalTitle>
        <FormattedMessage id={'subscription.pause.step.3.title'} defaultMessage={'Вашу підписку призупинено'} />
      </SubscriptionActionModalTitle>
      <SubscriptionActionModalText className={'cancel-text'}>
        <FormattedMessage
          id={'subscription.pause.step.3.test'}
          defaultMessage={'Ви можете будь-коли активувати свій план.'}
        />
      </SubscriptionActionModalText>
      <CustomButton buttonType={'primary'} onClick={handleClose}>
        <FormattedMessage id={'general.good.btn'} defaultMessage={'Добре'} />
      </CustomButton>
    </div>
  );
};

export default FinishStep;
